import getAll from "./get-all.js";

export default {
	getAll,
};
